import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {
    carouselContainer: 'lg:-mr-1',
    carouselControls: 'mx-6 b b-white rounded-full bg-white/75 flex h-11 w-11 shadow-sm center backdrop-blur-xs'
  },
  presets: {
    size: {
      height: {
        sm: 250
      },
      width: {
        sm: 250
      }
    }
  }
} satisfies CMSConfig['productRecommendations']
